import { mapActions, mapState } from "pinia"
import { useMainStore } from '@/store/main'

export default {
  computed: {
    ...mapState(useMainStore, ['isNavOpen'])
  },
  methods: {
    ...mapActions(useMainStore, ['toggleNav'])
  }
}
